import styled from 'styled-components';
import RouteFilter from './component';

import { selectStyles } from 'modules/filters/utils';

export default styled(RouteFilter)`
  ${selectStyles}
`;
